import styled from '@emotion/styled';
import {colors} from 'ui/config';
import {SmallTitle} from 'ui';

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end',
  marginBottom: 40,
  paddingBottom: 40,
  height: 434,
  backgroundPosition: 'center',
  maxWidth: 600,
  width: '100%',
  paddingLeft: 20,
  paddingRight: 20,
  alignItems: 'center',
});

export const SmallTitleWhite = styled(SmallTitle)({
  color: colors.white,
  marginTop: 4,
  marginBottom: 24,
});
